import './Contacts.css';
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ContactForm } from './ContactForm'; 
import { FaTelegramPlane } from 'react-icons/fa';
import Meta from './Meta';

export function Contacts() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);


  return (
      <React.Fragment>
      <Meta
        title="Контакты и поддержка — «ИТ Особа». Звоните для подключения услуг!"
        description="Адреса офисов, телефоны, электронная почта и форма обратной связи провайдера «ИТ Особа». Техническая поддержка 24/7. Как нас найти в Подольске и Московской области."
      />
      <div className="page-background">
          <section className="contacts-container position-relative" data-aos="fade-up" style={{overflow: 'hidden'}}>

              <h1 className="contacts-title" data-aos="fade-down" data-aos-delay="100">Контакты:</h1>
              <p className="contacts-description" data-aos="fade-up" data-aos-delay="200">
                  Обратитесь к нашим специалистам и получите профессиональную консультацию по всем вопросам
              </p>
              <div className="contacts-section" data-aos="fade-right" data-aos-delay="300">
                  <h2>Адрес офиса ООО "ИТ Особа":</h2>
                  <address>
                      улица Правды, 28<br/>
                      Подольск, Московская область, Россия
                  </address>
              </div>

              <div className="contacts-section" data-aos="fade-left" data-aos-delay="400">
                  <p><strong>Тел./факс:</strong>
                  <a href="tel:+74994033148" style={{ color: '#000000',
                                                      textDecoration: 'none',
                                                      fontWeight: '500',
                                                      cursor: 'pointer',
                                                      transition: 'color 0.3s',  }}>
                    +7 (499) 403-31-48
                  </a>
                  </p>
              </div>

              <div className="contacts-section" data-aos="fade-right" data-aos-delay="500">
                  <h2>Режим работы:</h2>
                  <p><strong>Абонентского отдела:</strong> с 9:00 до 18:00, выходные — суббота и воскресенье</p>
                  <p><strong>Технического отдела:</strong> с 9:00 до 21:00, без выходных</p>
              </div>

              <div className="contacts-section" data-aos="fade-left" data-aos-delay="600">
                  <h2>Контактные данные:</h2>
                  <address>
                      Юридический адрес:<br/>
                      142115, Московская область, г. Подольск, ул. Правды, д.28, корпус Главный, помещение №26
                  </address>
                  <p><strong>Почта:</strong> <a href="mailto:helpdesk@itosoba.ru"
                                                className="email-link"
                                                   style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >

                      <span>helpdesk@itosoba.ru</span>
                  </a>
                  </p>
                  <p>
                      <strong>Телеграм-бот для клиентов: </strong>
                      <a href="https://t.me/ItosobaClientBot" target="_blank" rel="noopener noreferrer"
                         className="telegram-link" style={{display: 'inline-flex', alignItems: 'center', gap: '6px'}}>
                          <FaTelegramPlane size={20} color="#0088cc"/> @ItosobaClientBot
                      </a>
                      </p>
                      <p>
                      <strong>Whatsapp:</strong>
                      <span className="whatsapp-container" style={{marginTop: '6px'}}>
                          <a
                            href="https://wa.me/+79263064040"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp-link"
                            style={{display: 'inline-flex', alignItems: 'center', gap: '8px'}}
                          >
                            <img
                              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                              alt="WhatsApp"
                              style={{width: '24px', height: '24px'}}
                            />
                            <span>89263064040</span>
                          </a>
                        </span>
                    </p>
              </div>
              {/* <ContactForm/>  */}
              <div className="map-container" data-aos="zoom-in" data-aos-delay="700">
                  <h2>Схема проезда</h2>
                  <iframe
                      title="Схема проезда - Яндекс.Карты"
                      src="https://yandex.ru/map-widget/v1/?ll=37.545728%2C55.404856&mode=routes&rtext=55.397823%2C37.532412~55.405925%2C37.559406&rtt=auto&z=15.07"
                      width="100%"
                      height="400"
                      style={{border: 0, borderRadius: '8px'}}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                  />
              </div>
          </section>
          </div>
          </React.Fragment>
              );
              }